module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei3.svg";